import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import EventApi from '../../../../Api/EventApi';
import { getResponseError } from '../../../../Api/Utils/apiUtils';
import AddTask from '../../../../Components/Accounts/AddTask/AddTask';
import TodoListItems from '../../../../Components/Accounts/TodoListItems/TodoListItems';
import ErrorAlert from '../../../../Components/Form/ErrorAlert/ErrorAlert';
import Section from '../../../../Components/Section/Section';
import './../../../../Components/Accounts/TodoListItems/todolist.css'

const TodoListComponent = () => {
    const { eventid } = useParams()
    const [isAdding, setisAdding] = useState(false);
    const [errorMessage, seterrorMessage] = useState(null);
    const [tasklist, settasklist] = useState([]);
    const [reloader, setreloader] = useState(0);

    useEffect(() => {
        const loadTasks = async () => {
            const respons = await EventApi.getTaskList(parseInt(eventid))
            const responsApiError = getResponseError(respons)
            if (responsApiError) {
                seterrorMessage(responsApiError)
            }else{
                const tasklistInfo = respons.objectVal
                settasklist(tasklistInfo)
            }
        }
        loadTasks()
    }, [eventid, reloader]);

    function goDefault() {
        setTimeout(() => {
            setreloader(0)
        }, 500);
    }

    // add task
    const addTasktoList = async (task) => {
        const taskdata = {
            title: task,
            eventId: parseInt(eventid)
        }
        const respons = await EventApi.addTaskInList(taskdata)
        const responseApiError = getResponseError(respons)
        if (responseApiError) {
            seterrorMessage(responseApiError)
            setisAdding(false)
        }else{
            if(respons.success === "true"){
                setreloader(2)
                goDefault()
                setisAdding(false)
            }
        }
    }

    // mark as complete or uncomplete
    const markAsComplete = async (todoID, isdone) => {
        const completedata = {
            toDoId: todoID,
            isDone: isdone
        }
        const response = await EventApi.markAsComplete(completedata)
        const responseApiError = getResponseError(response)
        if (responseApiError) {
            seterrorMessage(responseApiError)
        }else{
            if (response.success === "true") {
                setreloader(1)
                goDefault()
            }
        }
    }

    return(
        <>
        {isAdding ?
        <>
            <div className="empty-space" style={{width: '100%', minHeight: "600px"}}></div>
            <AddTask CanclleAdd={setisAdding} addTask={addTasktoList} />
        </>
        :
        <Section>
            <Container>
                <ErrorAlert>{errorMessage}</ErrorAlert>
                <div className="todo-list-container">
                    <TodoListItems alltask={tasklist} setTaskComplete={markAsComplete} />
                    <div className="add-task-button" onClick={() => setisAdding(true)}>
                        <FontAwesomeIcon icon={faPlus} />
                    </div>
                </div>
            </Container>
        </Section>}
        </>
    );
};

export default TodoListComponent;
